import React, { Component } from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

import ong from '../../images/about/our-leader-team/Ong Lay Fung.webp'
import christianlisangan from '../../images/about/our-leader-team/Christian Lisangan.webp'
import thomas from "../../images/about/our-leader-team/Whisnu Thomas Julianto.webp"
import steven from '../../images/about/our-leader-team/Steven Amadeus.webp'
import fathi from "../../images/about/our-leader-team/Fathi Amin.webp"
import YuniarKurnata from '../../images/about/our-leader-team/Yuniar Kurnata.webp'

const content = [
  {
    image: thomas,
    name: "Whisnu Thomas Julianto",
    title: "HRGA Head",
    idDetail: 1,
  },
  {
    image: fathi,
    name: "Fathi Amin",
    title: "RA Manager",
    idDetail: 2,
  },
  {
    image: YuniarKurnata,
    name: "Yuniar Kurnata",
    title: "FAT Senior Manager",
    idDetail: 3,
  },
  {
    image: christianlisangan,
    name: "Christian Lisangan",
    title: "FAT Manager",
    idDetail: 4,
  },
  {
    image: ong,
    name: "Ong Lay Fung",
    title: "RA SG, EMA, and Quality Assurance Sr. Manager",
    idDetail: 5,
  },
  // {
  //   image: steven,
  //   name: "Yustina Irene",
  //   title: "Strategic MS Manager",
  //   idDetail: 6,
  // },
  {
    image: steven,
    name: "Steven Amadeus",
    title: "IT Manager",
    idDetail: 7,
  },
]

class TeamSliderCustom2 extends Component {
  render() {
    const settings = {
      // dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: false,
      responsive: [
        {
          breakpoint: 2560,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    }
    return (
      <>
        <Slider
          {...settings}
          className="dlab-team11-area dots-theme dots-long d-primary btn-style-1"
        >
          {/* {content.map((item, id) => (
                        <div key={id} class="item wow fadeInUp" data-wow-duration="2s" data-wow-delay="0.2s">
                            <div class="dlab-box dlab-team11">
                                <div class="dlab-media dlab-img-effect custom-size">                                   
                                    <img src={item.image} alt="team-img" />
                                </div>
                                <div class="dlab-info">
                                    <h4 class="dlab-title">{item.name}</h4>
                                    <span class="dlab-position">{item.title}</span>
                                </div>
                            </div>
                        </div>
                    ))} */}
          {content.map((item, id) => {
            console.log(item)
            return (
              <div
                key={id}
                class="item wow fadeInUp"
                data-wow-duration="2s"
                data-wow-delay="0.2s"
              >
                <div class="dlab-box dlab-team11">
                  <div class="dlab-media dlab-img-effect custom-size">
                    {/* {item.idDetail === 5 || item.idDetail === 9 ? (
                      <img
                        src={item.image}
                        alt="team-img"
                        style={{ transform: "scaleX(-1)" }}
                      />
                    ) : (
                      <img src={item.image} alt="team-img" />
                    )} */}
                    <img src={item.image} alt="team-img" />
                  </div>
                  <div class="dlab-info">
                    <h4 class="dlab-title">{item.name}</h4>
                    <span class="dlab-position">{item.title}</span>
                  </div>
                </div>
              </div>
            )
          })}
        </Slider>
      </>
    )
  }
}
export default TeamSliderCustom2
